import { render, staticRenderFns } from "./DropdownMenuItem.vue?vue&type=template&id=bf2d3ef8&scoped=true"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=js"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=js"
import style0 from "./DropdownMenuItem.vue?vue&type=style&index=0&id=bf2d3ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2d3ef8",
  null
  
)

export default component.exports